import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { fetchMarks } from '../../Lookups/util';
import CourseGradingTable from './CourseGradingTable';
import { Message } from 'semantic-ui-react';

class ExternalStudentGrades extends Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: [],
            marks: [],
            loading: false,
            error: false,
        };
    }

    componentDidMount() {
        this.setState({ loading: true });
        Promise.all([
            axios.get(`/external-student-course/graded-activity/${localStorage.getItem('gradedActivityId')}`),
            fetchMarks()
        ])
            .then(([coursesRes, marksRes]) => {
                const marks = marksRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length)
                        ? el.translations.find(e => e.language === window.$locale).displayName
                        : el.displayName),
                }));
                this.setState({
                    courses: coursesRes.data,
                    marks,
                    loading: false
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    error: true
                });
            });
    }

    handleSave = (editingRowId, editedRowData) => {
        return axios.put('/external-student-course', {
            id: editingRowId,
            markId: editedRowData.markId || null,
            dateOfExam: editedRowData.dateOfExam ? new Date(editedRowData.dateOfExam) : null,
        })
            .then(() => {
                return axios.get(`/external-student-course/graded-activity/${localStorage.getItem('gradedActivityId')}`);
            })
            .then(res => {
                this.setState({ courses: res.data });
                toast(<FormattedMessage id="externalStudent.toast.courseUpdated"/>);
            })
            .catch(() => {
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
                throw new Error();
            });
    };

    handleShowDetails = (course) => {
        localStorage.setItem('externalStudentId', course.externalStudentId);
        this.props.history.push('/dolazne-mobilnosti/student');
    };

    render() {
        const {
            courses,
            marks,
            loading
        } = this.state;
        return (
            <Fragment>
                <Message>
                    <FormattedMessage id="externalStudent.gradesInfo"/>
                </Message>
                <CourseGradingTable
                    courses={courses}
                    marks={marks}
                    loading={loading}
                    onSave={this.handleSave}
                    onShowDetails={this.handleShowDetails}
                />
            </Fragment>
        );
    }
}

export default withRouter(ExternalStudentGrades);



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/ExternalStudentGrades.js